export const titular = [
    {
        "nombre" : "",
        // "nombre" : "Napoleón González Pérez",
        "imagen" : "https://cdn.hidalgo.gob.mx/gobierno/images/gabinete/NapoleonGonzalezPerez.png",
        //"imagen" : "https://cdn.hidalgo.gob.mx/gobierno/images/veda/titular_veda.png",
        //  "imagen": "../img/secretario.png",
        "funcion" : "..."
    }
]